module.exports = __webpack_public_path__ + "img/220.4ef791d5.jpg";